import React, { useMemo } from 'react';
import { Avatar, Col, Row, Badge } from 'antd';
import { Dropdown } from '@app/components/common/Dropdown/Dropdown';
import { H6 } from '@app/components/common/typography/H6/H6';
import { ProfileOverlay } from '../ProfileOverlay/ProfileOverlay';
import { useResponsive } from '@app/hooks/useResponsive';
import { useKeycloak } from '@react-keycloak/web';
import { UserOutlined } from '@ant-design/icons';
import * as S from './ProfileDropdown.styles';

export const ProfileDropdown: React.FC = () => {
  const { isTablet } = useResponsive();
  const { keycloak } = useKeycloak();

  /** dados básicos do usuário */
  const { name, preferred_username, email_verified, picture } =
    keycloak.tokenParsed || {};

  /** avatar usando iniciais se não houver picture */
  const initials = useMemo(() => {
    if (name) {
      const parts = String(name).split(' ');
      return (
        parts[0][0].toUpperCase() + (parts[1] ? parts[1][0].toUpperCase() : '')
      );
    }
    return preferred_username?.slice(0, 2).toUpperCase();
  }, [name, preferred_username]);

  return (
    <Dropdown overlay={<ProfileOverlay />} trigger={['click']}>
      <S.ProfileDropdownHeader as={Row} gutter={[10, 10]} align="middle">
        <Col>
          <Badge
            status={email_verified ? 'success' : 'error'}
            offset={[-2, 38]}
            title={email_verified ? 'Email verificado' : 'Email não verificado'}
          >
            <Avatar
              src={picture}
              icon={<UserOutlined />}
              size={40}
              style={{ backgroundColor: '#8bb' }}
            >
              {!picture && initials}
            </Avatar>
          </Badge>
        </Col>

        {isTablet && (
          <Col>
            <H6>{name || preferred_username}</H6>
          </Col>
        )}
      </S.ProfileDropdownHeader>
    </Dropdown>
  );
};
